import { HierarchicalLabelOrFolder } from '../../store/Inbox/Labels/types';
import { getItemId } from '../../utils/getItemIdForLabelsAndFolders';

export const useFindLabelFamily = (labels: HierarchicalLabelOrFolder[]) => {
  const findLabelFamily = (targetId: string): HierarchicalLabelOrFolder[] => {
    const findPath = (
      label: HierarchicalLabelOrFolder,
      path: HierarchicalLabelOrFolder[],
    ): HierarchicalLabelOrFolder[] | null => {
      if (getItemId(label) === targetId) {
        return [...path, label];
      }

      for (const child of label.children as HierarchicalLabelOrFolder[]) {
        const result = findPath(child, [...path, label]);
        if (result) return result;
      }

      return null;
    };

    for (const label of labels) {
      const result = findPath(label, []);
      if (result) {
        return result;
      }
    }

    return [];
  };

  return {
    findLabelFamily,
  };
};
